var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-2"},[_vm._m(0),_c('a-form',{staticClass:"mod-form",attrs:{"layout":"horizontal","labelAlign":"left","label-col":_vm.labelCol,"wrapper-col":_vm.wrapperCol,"colon":false,"form":_vm.form},on:{"submit":_vm.onSubmit}},[_c('a-form-item',{attrs:{"label":"中文姓"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'surname',
          {
            initialValue: _vm.userInfo.chiSurname,
            rules: [
              {
                required: true,
                validator: _vm.handleFieldValidate
              }
            ],
            validateTrigger: 'blur'
          }
        ]),expression:"[\n          'surname',\n          {\n            initialValue: userInfo.chiSurname,\n            rules: [\n              {\n                required: true,\n                validator: handleFieldValidate\n              }\n            ],\n            validateTrigger: 'blur'\n          }\n        ]"}],attrs:{"size":"large","placeholder":"请输入姓","disabled":_vm.hasAuth}})],1),_c('a-form-item',{attrs:{"label":"中文名"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'name',
          {
            initialValue: _vm.userInfo.chiName,
            rules: [
              {
                required: true,
                validator: _vm.handleFieldValidate
              }
            ],
            validateTrigger: 'blur'
          }
        ]),expression:"[\n          'name',\n          {\n            initialValue: userInfo.chiName,\n            rules: [\n              {\n                required: true,\n                validator: handleFieldValidate\n              }\n            ],\n            validateTrigger: 'blur'\n          }\n        ]"}],attrs:{"size":"large","placeholder":"请输入名","disabled":_vm.hasAuth}})],1),_c('a-form-item',{attrs:{"label":"身份类别"}},[_c('a-select',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'type',
          {
            rules: [
              {
                required: true,
                validator: _vm.handleFieldValidate
              }
            ],
            validateTrigger: 'blur'
          }
        ]),expression:"[\n          'type',\n          {\n            rules: [\n              {\n                required: true,\n                validator: handleFieldValidate\n              }\n            ],\n            validateTrigger: 'blur'\n          }\n        ]"}],attrs:{"size":"large","placeholder":"请选择身份类别","options":_vm.idTypes}})],1),_c('a-form-item',{attrs:{"label":"证件号码"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'idCard',
          {
            rules: [
              {
                required: true,
                validator: _vm.handleFieldValidate
              }
            ],
            validateTrigger: 'blur'
          }
        ]),expression:"[\n          'idCard',\n          {\n            rules: [\n              {\n                required: true,\n                validator: handleFieldValidate\n              }\n            ],\n            validateTrigger: 'blur'\n          }\n        ]"}],attrs:{"size":"large","placeholder":"请输入申请认证的证件号码"}})],1),_c('a-form-item',{attrs:{"label":"工作单位/学校"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'organization',
          {
            rules: [
              {
                required: true,
                validator: _vm.handleFieldValidate
              }
            ],
            validateTrigger: 'blur'
          }
        ]),expression:"[\n          'organization',\n          {\n            rules: [\n              {\n                required: true,\n                validator: handleFieldValidate\n              }\n            ],\n            validateTrigger: 'blur'\n          }\n        ]"}],attrs:{"size":"large","placeholder":"请输入申请认证的证件上单位/学校全称"}})],1),_c('a-form-item',{attrs:{"label":"手机号码"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'mobile',
          {
            initialValue: _vm.userInfo.phone,
            rules: [
              {
                required: true,
                validator: _vm.handleFieldValidate
              }
            ],
            validateTrigger: 'blur'
          }
        ]),expression:"[\n          'mobile',\n          {\n            initialValue: userInfo.phone,\n            rules: [\n              {\n                required: true,\n                validator: handleFieldValidate\n              }\n            ],\n            validateTrigger: 'blur'\n          }\n        ]"}],attrs:{"size":"large","placeholder":"请输入手机号码"}})],1),_c('a-form-item',{attrs:{"label":"E-MAIL"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'email',
          {
            rules: [
              {
                validator: _vm.handleFieldValidate
              }
            ],
            validateTrigger: 'blur'
          }
        ]),expression:"[\n          'email',\n          {\n            rules: [\n              {\n                validator: handleFieldValidate\n              }\n            ],\n            validateTrigger: 'blur'\n          }\n        ]"}],attrs:{"size":"large","placeholder":"请输入E-MAIL"}})],1),_c('a-form-item',{attrs:{"label":"上传附件","required":""}},[_c('p',{staticClass:"upload-tips"},[_vm._v("（上限5个，每个附件大小不超过5M，仅支持png、jpg、jpeg格式）")]),_c('div',{staticClass:"file-upload-trigger clearfix"},[_c('a-upload',{attrs:{"file-list":_vm.fileList,"customRequest":_vm.handleUpload,"list-type":"picture-card","name":"filename","accept":".png, .jpg, .jpeg","headers":{
            token: _vm.token
          },"transformFile":_vm.handleTransformFile,"beforeUpload":_vm.handleBeforeUpload,"locale":{
            removeFile: '删除',
            previewFile: '预览'
          }},on:{"preview":_vm.handlePreview,"change":_vm.handleUploadChange}},[(_vm.fileList.length < _vm.fileLimit)?_c('div',[_c('a-icon',{attrs:{"type":"plus"}})],1):_vm._e()]),_c('a-modal',{attrs:{"visible":_vm.previewVisible,"footer":null},on:{"cancel":_vm.handleCancelPreview}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"alt":"example","src":_vm.previewImage}})])],1)]),_c('a-form-item',{attrs:{"wrapper-col":_vm.wrapperColOffset}},[_c('a-button',{staticStyle:{"margin-right":"20px"},attrs:{"size":"large"},on:{"click":_vm.onPrev}},[_vm._v("返回")]),_c('a-button',{attrs:{"type":"primary","size":"large","loading":_vm.loading,"html-type":"submit"}},[_vm._v("提交")])],1)],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header"},[_c('h2',[_vm._v("职业身份认证申请")])])
}]

export { render, staticRenderFns }